{
  "title": "Innstillinger",
  "panel": {
    "createTitle": "Opprett {{title}}",
    "updateTitle": "Oppdater {{title}}",
    "createDescription": "Opprett {{title}}.",
    "updateDescription": "Oppdater {{title}}.",
    "removeTitle": "Fjern {{title}}",
    "removeText": "Er du sikker på at du vil fjerne denne {{title}}? Denne handlingen kan ikke angres.",
    "closePanel": "Lukk panel",
    "remove": "Fjern",
    "test": "Test",
    "ok": "OK!",
    "error": "FEIL",
    "cancel": "Avbryt",
    "create": "Opprett",
    "save": "Lagre"
  },
  "nav": {
    "application": "Applikasjon",
    "logs": "Logger",
    "indexers": "Indekserere",
    "irc": "IRC",
    "feeds": "Feeder",
    "lists": "Lister",
    "clients": "Klienter",
    "notifications": "Varsler",
    "apiKeys": "API-nøkler",
    "proxies": "Proxyer",
    "releases": "Utgivelser",
    "account": "Konto"
  },
  "application": {
    "title": "Applikasjon",
    "description": "Applikasjoninnstillinger. Endre i config.toml og start på nytt for at endringene skal tre i kraft.",
    "host": "Vert",
    "port": "Port",
    "baseUrl": "Basis-URL",
    "version": "Versjon",
    "commit": "Commit",
    "buildDate": "Byggedato",
    "application": "Applikasjon",
    "configPath": "Konfigurasjonssti",
    "database": "Database",
    "webuiDebugMode": "WebUI-feilsøkingsmodus",
    "checkForUpdates": "Se etter oppdateringer",
    "checkForUpdatesDescription": "Bli varslet om nye oppdateringer.",
    "theme": "Tema",
    "themeDescription": "Velg mellom lyst, mørkt eller følg systemtemaet.",
    "languageDescription": "Velg språket som brukes i WebUI.",
    "updateEnabled": "Du vil nå bli varslet om nye oppdateringer.",
    "updateDisabled": "Du vil ikke lenger bli varslet om nye oppdateringer.",
    "updateAvailable": "{{name}} tilgjengelig!"
  },
  "account": {
    "title": "Konto",
    "description": "Administrer kontoinnstillinger.",
    "required": "Påkrevd",
    "passwordsDoNotMatch": "Passordene stemmer ikke overens!",
    "updateSuccess": "Brukeren ble oppdatert. Logg inn på nytt!",
    "updateError": "Feil ved oppdatering av påloggingsopplysninger. Oppga du riktig nåværende passord?",
    "changeCredentialsTitle": "Endre påloggingsopplysninger",
    "changeCredentialsDescription": "Brukernavn og passord kan endres enten separat eller samtidig. Merk at du blir logget ut etter at påloggingsopplysningene er endret.",
    "currentUsername": "Nåværende brukernavn",
    "newUsername": "Nytt brukernavn",
    "optional": "Valgfritt",
    "currentPassword": "Nåværende passord",
    "requiredIfUpdatingCredentials": "Påkrevd ved oppdatering av påloggingsopplysninger",
    "newPassword": "Nytt passord",
    "confirmNewPassword": "Bekreft nytt passord",
    "save": "Lagre",
    "identityProvider": "identitetsleverandør",
    "oidcTitle": "OpenID Connect-konto",
    "oidcDescription": "Kontoinformasjonen din administreres av OpenID Connect-leverandøren din. For å endre brukernavnet ditt, gå til leverandørens innstillingsside og logg inn på nytt.",
    "authenticatedViaOidc": "Autentisert via OpenID Connect"
  },
  "logsPage": {
    "title": "Logger",
    "description": "Konfigurer loggnivå, rotasjon av loggstørrelse osv. Du kan laste ned de gamle loggfilene dine nedenfor.",
    "chooseType": "Velg en type",
    "updated": "Konfigurasjonen ble oppdatert!",
    "path": "Sti",
    "setInConfig": "Angitt i config.toml",
    "notSet": "Ikke angitt!",
    "level": "Nivå",
    "logLevel": "Loggnivå",
    "maxSize": "Maks størrelse",
    "maxBackups": "Maks antall sikkerhetskopier"
  },
  "regexPlayground": {
    "title": "Regex Playground",
    "description": "Regex-lekeplass. Eksperimenter med filtrene dine her. WIP.",
    "regexFilter": "RegExp-filter",
    "linesToMatch": "Linjer som skal samsvare",
    "matches": "Treff"
  },
  "apiKey": {
    "createTitle": "Opprett API-nøkkel",
    "description": "Legg til ny API-nøkkel.",
    "created": "API-nøkkelen {{name}} ble lagt til",
    "deleted": "API-nøkkelen {{name}} ble slettet",
    "name": "Navn",
    "key": "Nøkkel",
    "required": "Påkrevd",
    "closePanel": "Lukk panel",
    "cancel": "Avbryt",
    "create": "Opprett",
    "listTitle": "API-nøkler",
    "listDescription": "Administrer autobrr API-nøklene dine her.",
    "addNew": "Legg til ny",
    "noItems": "Ingen API-nøkler",
    "createCta": "Opprett API-nøkkel",
    "removeTitle": "Fjern API-nøkkel: {{name}}",
    "removeText": "Er du sikker på at du vil fjerne denne API-nøkkelen? Denne handlingen kan ikke angres.",
    "deleteKey": "Slett nøkkel"
  },
  "irc": {
    "listTitle": "IRC",
    "listDescription": "IRC-nettverk og kanaler. Klikk på et nettverk for å se kanalstatus.",
    "addNew": "Legg til ny",
    "networkHealthy": "Nettverket er friskt",
    "networkUnhealthy": "Nettverket er ustabilt",
    "networkDisabled": "Nettverket er deaktivert",
    "collapseTitle": "kollaps",
    "expandTitle": "utvid",
    "collapse": "Kollaps",
    "expand": "Utvid",
    "network": "Nettverk",
    "noNetworks": "Ingen nettverk",
    "noNetworksSubtitle": "Settes vanligvis opp via indekserere",
    "addNewNetwork": "Legg til nytt nettverk",
    "toggleSuccess": "{{name}} ble {{state}}.",
    "enabledState": "aktivert",
    "disabledState": "deaktivert",
    "connectedSince": "Tilkoblet siden: {{time}}",
    "tlsSecured": "Sikret med TLS",
    "tlsInsecure": "Usikret, bruker ikke TLS",
    "channel": "Kanal",
    "monitoringSince": "Overvåker siden",
    "lastAnnounce": "Siste annonsering",
    "monitoring": "overvåker",
    "hide": "Skjul",
    "view": "Vis",
    "networkDeleted": "Nettverket {{name}} ble slettet",
    "networkRestarted": "{{name}} ble startet på nytt",
    "removeNetworkTitle": "Fjern nettverk: {{name}}",
    "removeNetworkText": "Er du sikker på at du vil fjerne dette nettverket? Denne handlingen kan ikke angres.",
    "edit": "Rediger",
    "restart": "Start på nytt",
    "delete": "Slett",
    "announceReprocessed": "Annonsering sendt til ny behandling!",
    "reprocessAnnounce": "Behandle annonsering på nytt",
    "options": "Alternativer",
    "scrollOnNewMessage": "Rull til bunnen ved ny melding",
    "title": "Nettverk",
    "addWarning": "LEGG TIL NETTVERK VIA INDEKSERERE! BRUK KUN DETTE HVIS DU HAR SLETTET NETTVERK",
    "added": "IRC-nettverk lagt til. Det kan ta opptil 30 sekunder før nettverket kommer på nett.",
    "addFailed": "IRC-nettverket kunne ikke legges til",
    "updated": "{{name}} ble oppdatert",
    "deleted": "{{name}} ble slettet.",
    "required": "Påkrevd",
    "name": "Navn",
    "enabled": "Aktivert",
    "server": "Server",
    "serverPlaceholder": "Adresse: f.eks. irc.server.net",
    "port": "Port",
    "portPlaceholder": "F.eks. 6667",
    "tls": "TLS",
    "skipTls": "Hopp over TLS-verifisering (usikkert)",
    "password": "Passord",
    "passwordHelp": "Nettverkspassord",
    "passwordUpdateHelp": "Nettverkspassord, brukes vanligvis ikke.",
    "nick": "Nick",
    "nickPlaceholderAdd": "bot-nick",
    "nickPlaceholderUpdate": "nick",
    "authAccount": "Autentiseringskonto",
    "authAccountPlaceholder": "Autentiseringskonto",
    "authPassword": "Autentiseringspassord",
    "inviteCommand": "Invitasjonskommando",
    "channels": "Kanaler",
    "channelsDesc": "Kanaler som skal kobles til.",
    "channelsUpdateDesc": "Kanaler legges til når du setter opp IRC-indekserere. Ikke rediger med mindre du vet hva du gjør.",
    "channelPassword": "Kanalpassord",
    "remove": "Fjern",
    "noChannels": "Ingen kanaler!",
    "addChannel": "Legg til kanal",
    "bouncer": "Bouncer (BNC)",
    "bouncerAddress": "Bouncer-adresse",
    "bouncerAddressHelp": "Adresse: f.eks. bouncer.server.net:6697",
    "botMode": "IRCv3 Bot-modus",
    "proxy": "Proxy",
    "proxyDesc": "Angi en proxy som skal brukes ved tilkobling til IRC-serveren.",
    "selectProxy": "Velg proxy",
    "selectProxyPlaceholder": "Velg en proxy",
    "identification": "Identifisering",
    "identificationDesc": "Identifiser med SASL eller NickServ. De fleste nettverk støtter SASL, men noen gjør det ikke.",
    "mechanism": "Mekanisme",
    "account": "Konto",
    "accountHelp": "NickServ- / SASL-konto. For grupperte nick, prøv hovedkontoen.",
    "passwordSaslHelp": "NickServ- / SASL-passord.",
    "chooseType": "Velg en type"
  },
  "releases": {
    "warningTitle": "Advarsel:",
    "warningBody": "Denne seksjonen administrerer sletting av utgivelseshistorikk. Automatiske oppryddingsjobber kjører etter tidsplaner, mens manuell sletting tillater umiddelbar engangsopprydding. Begge operasjoner sletter data permanent og kan ikke angres.",
    "olderThan": "Eldre enn",
    "olderThanDesc": "Hvor gamle utgivelser må være før sletting (påkrevd for både automatisk og manuell sletting)",
    "indexers": "Indekserere",
    "indexersDesc": "Valgfritt filter (hvis ingen er valgt, gjelder det alle indekserere)",
    "releaseStatuses": "Utgivelsesstatuser",
    "releaseStatusesDesc": "Valgfritt filter (hvis ingen er valgt, gjelder det alle utgivelsesstatuser)",
    "duplicateProfilesTitle": "Duplikatprofiler for utgivelser",
    "duplicateProfilesDesc": "Administrer duplikatprofiler.",
    "cleanupJobsTitle": "Oppryddingsjobber for utgivelser",
    "cleanupJobsDesc": "Planlegg automatisk opprydding av gamle utgivelser med egendefinerte filtre.",
    "addNew": "Legg til ny",
    "edit": "Rediger",
    "enabled": "Aktivert",
    "name": "Navn",
    "lastRun": "Siste kjøring",
    "nextRun": "Neste kjøring",
    "runNow": "Kjør nå",
    "delete": "Slett",
    "never": "Aldri",
    "deleteReleaseHistory": "Slett utgivelseshistorikk",
    "deleteReleaseHistoryDesc": "Velg kriteriene nedenfor for å slette historikkoppføringer for utgivelser permanent som er eldre enn valgt alder og eventuelt samsvarer med de valgte indeksererne og utgivelsesstatusene:",
    "removeReleases": "Fjern utgivelser",
    "invalidAge": "Velg en gyldig alder.",
    "invalidAgeExample": "Oppgi en gyldig alder. For eksempel 6 måneder eller 1 år.",
    "allDeleted": "Alle utgivelser basert på kriteriene ble slettet.",
    "olderThanDeleted": "Utgivelser eldre enn {{duration}} ble slettet.",
    "allIndexers": "alle indekserere",
    "selectedIndexers": "de valgte indeksererne",
    "removeCleanupJobTitle": "Fjern oppryddingsjobb: {{name}}",
    "removeCleanupJobText": "Er du sikker på at du vil fjerne denne oppryddingsjobben? Denne handlingen kan ikke angres.",
    "cleanupJobToggled": "{{name}} {{state}}",
    "cleanupJobTriggered": "{{name}} utløst",
    "cleanupJobDeleted": "{{name}} slettet",
    "cleanupJobEnabled": "aktivert",
    "cleanupJobDisabled": "deaktivert",
    "duplicateFieldTitles": {
      "releaseName": "Utgivelsesnavn",
      "hash": "Normalisert hash for utgivelsesnavnet. Bruk med utgivelsesnavn for eksakt samsvar",
      "title": "Tolket tittel",
      "subTitle": "Tolket undertittel, som episodenavn",
      "group": "Utgivelsesgruppe",
      "year": "År",
      "month": "Måned",
      "day": "Dag",
      "source": "Kilde",
      "resolution": "Oppløsning",
      "codec": "Kodek",
      "container": "Container",
      "dynamicRange": "Dynamisk område (HDR,DV)",
      "audio": "Lydformater",
      "season": "Sesongnummer",
      "episode": "Episodenummer",
      "website": "Nettsted/tjeneste",
      "proper": "Scene proper",
      "repack": "Scene repack",
      "edition": "Utgave (f.eks. Collectors Edition) og Cut (f.eks. Directors Cut)",
      "language": "Språk og region"
    },
    "noDuplicateProfiles": "Ingen duplikatprofiler for utgivelser",
    "addNewProfile": "Legg til ny profil",
    "noCleanupJobs": "Ingen oppryddingsjobber",
    "createCleanupSchedules": "Opprett automatiske oppryddingsplaner",
    "addNewJob": "Legg til ny jobb",
    "removeReleasesText": "Du er i ferd med å {{scope}}.",
    "removeReleasesScopeAll": "slette alle historikkoppføringer for utgivelser for {{indexers}}{{statuses}}",
    "removeReleasesScopeOlder": "slette alle historikkoppføringer for utgivelser eldre enn {{duration}} permanent for {{indexers}}{{statuses}}",
    "removeReleasesStatuses": " og med følgende utgivelsesstatuser: {{statuses}}",
    "duration": {
      "allTime": "all tid",
      "hour1": "1 time",
      "hours12": "12 timer",
      "day1": "1 dag",
      "week1": "1 uke",
      "month1": "1 måned",
      "months3": "3 måneder",
      "months6": "6 måneder",
      "year1": "1 år",
      "invalid": "Ugyldig varighet"
    }
  },
  "forms": {
    "downloadClient": {
      "remove": "Fjern",
      "test": "Test",
      "ok": "OK!",
      "error": "FEIL",
      "cancel": "Avbryt",
      "create": "Opprett",
      "save": "Lagre",
      "added": "Klienten ble lagt til",
      "addFailed": "Klienten kunne ikke legges til",
      "updated": "{{name}} ble oppdatert",
      "deleted": "{{name}} ble slettet.",
      "addTitle": "Legg til klient",
      "addDescription": "Legg til nedlastingsklient.",
      "editTitle": "Rediger klient",
      "editDescription": "Rediger innstillinger for nedlastingsklient.",
      "removeTitle": "Fjern nedlastingsklient",
      "removeText": "Er du sikker på at du vil fjerne denne nedlastingsklienten? Denne handlingen kan ikke angres.",
      "closePanel": "Lukk panel",
      "name": "Navn",
      "enabled": "Aktivert",
      "type": "Type",
      "host": "Vert",
      "port": "Port",
      "tls": "TLS",
      "skipTls": "Hopp over TLS-verifisering (usikkert)",
      "username": "Brukernavn",
      "password": "Passord",
      "apiKey": "API-nøkkel",
      "authToken": "Autentiseringstoken",
      "basicAuth": "Grunnleggende autentisering (Basic auth)",
      "auth": "Autentisering",
      "authType": "Autentiseringstype",
      "selectAuthType": "Velg autentiseringstype",
      "authTypeTooltip": "Dette bør i de fleste tilfeller være Basic Auth, men noen leverandører bruker Digest Auth.",
      "hostHelpDeluge": "F.eks. klient.domene.no, domene.no/klient, domene.no:port",
      "hostHelpArr": "Full URL http(s)://domene.no og/eller underdomene/undermappe",
      "hostHelpQbit": "F.eks. http(s)://klient.domene.no, http(s)://domene.no/qbittorrent, http://domene.no:port",
      "hostHelpPorla": "F.eks. http(s)://klient.domene.no, http(s)://domene.no/porla, http://domene.no:port",
      "hostHelpAria2": "F.eks. http://localhost:6800, http(s)://domene.no/aria2",
      "rpcSecret": "RPC-token",
      "rpcSecretHelp": "Verdien av --rpc-secret. La stå tom hvis aria2 kjører uten token.",
      "hostHelpRTorrent": "F.eks. http(s)://klient.domene.no/RPC2, http(s)://domene.no/klient, http(s)://domene.no/RPC2",
      "hostHelpTransmission": "F.eks. http(s)://klient.domene.no, http(s)://domene.no/transmission",
      "hostHelpSabnzbd": "F.eks. http://ip:port eller https://url.no/sabnzbd",
      "hostHelpNzbget": "F.eks. http://localhost:6789",
      "daemonPort": "Daemon-port",
      "webUiPortQbit": "WebUI-port for qBittorrent",
      "transmissionPort": "Port for Transmission",
      "sabnzbdPort": "Port for SABnzbd",
      "guidesDeluge": "Se guider for hvordan du kobler til Deluge for ulike servertyper i dokumentasjonen vår.",
      "guidesArr": "Se guider for hvordan du kobler til *arr-applikasjonene for ulike servertyper i dokumentasjonen vår.",
      "guidesQbit": "Se guider for hvordan du kobler til qBittorrent for ulike servertyper i dokumentasjonen vår.",
      "guidesRTorrent": "Se guider for hvordan du kobler til rTorrent for ulike servertyper i dokumentasjonen vår.",
      "guidesTransmission": "Se guider for hvordan du kobler til Transmission for ulike servertyper i dokumentasjonen vår.",
      "guidesSabnzbd": "Se guider for hvordan du kobler til SABnzbd for ulike servertyper i dokumentasjonen vår.",
      "dedicatedServers": "Dedikerte servere:",
      "sharedSeedboxProviders": "Delte seedbox-leverandører:",
      "rulesTitle": "Regler",
      "rulesDescriptionBasic": "Administrer maks antall nedlastinger.",
      "rulesDescriptionAdvanced": "Administrer maks antall nedlastinger osv.",
      "maxActiveDownloads": "Maks antall aktive nedlastinger",
      "maxActiveDownloadsTooltip": "Begrens antall aktive nedlastinger (0 er ubegrenset) for å gi maksimal mengde båndbredde og diskplass til nedlastingene.",
      "seeRecommendations": "Se anbefalinger for ulike servertyper her:",
      "downloadClientTitle": "Nedlastingsklient",
      "downloadClientDescription": "Overstyr hvilken nedlastingsklient som skal brukes. Kan også overstyres per filterhandling.",
      "clientName": "Klientnavn",
      "clientNameTooltip": "Spesifiser hvilken klient arr-applikasjonen skal bruke som standard. Kan overstyres per filterhandling.",
      "clientIdDeprecated": "Klient-ID AVLEGS (DEPRECATED)",
      "clientIdDeprecatedTooltip": "AVLEGS: Bruk feltet Klientnavn i stedet.",
      "ignoreSlowTorrents": "Ignorer trege torrenter",
      "ignoreCondition": "Ignoreringsbetingelse",
      "selectIgnoreCondition": "Velg ignoreringsbetingelse",
      "ignoreConditionTooltip": "Velg om innstillingen for 'Maks antall aktive nedlastinger' skal respekteres eller ignoreres før hastighetsgrensene sjekkes.",
      "downloadSpeedThreshold": "Nedlastingshastighetsgrense",
      "uploadSpeedThreshold": "Opplastingshastighetsgrense",
      "speedThresholdPlaceholder": "i KB/s",
      "downloadSpeedThresholdHelp": "Hvis nedlastingshastigheten er under dette når maks antall aktive nedlastinger er nådd, last ned uansett. KB/s",
      "uploadSpeedThresholdHelp": "Hvis opplastingshastigheten er under dette når maks antall aktive nedlastinger er nådd, last ned uansett. KB/s"
    },
    "feed": {
      "title": "Feed",
      "updated": "{{name}} ble oppdatert",
      "deleted": "{{name}} ble slettet.",
      "testOk": "{{name}} test OK!",
      "name": "Navn",
      "type": "Type",
      "enabled": "Aktivert",
      "warningTitle": "Advarsel: Indekserere kan utestenge deg for for lavt intervall!",
      "warningText": "Les reglene til indeksereren.",
      "url": "URL",
      "torznabUrlHelp": "Torznab-URL. Bruk kun URL-en uten ekstra parametere.",
      "newznabUrlHelp": "Newznab-URL. Bruk kun URL-en uten ekstra parametere.",
      "rssUrlHelp": "RSS-URL",
      "urlFormatTitle": "Prowlarr og Jackett har forskjellige formater:",
      "prowlarr": "Prowlarr",
      "jackett": "Jackett",
      "downloadType": "Nedlastingstype",
      "apiKey": "API-nøkkel",
      "skipTls": "Hopp over TLS-verifisering (usikkert)",
      "refreshInterval": "Oppdateringsintervall",
      "refreshIntervalHelp": "Minutter. Anbefalt er 15-30. For lavt kan risikere utestengelse.",
      "refreshTimeout": "Tidsavbrudd for oppdatering",
      "refreshTimeoutHelp": "Sekunder å vente før oppdateringen avbrytes.",
      "maxAge": "Maks alder",
      "maxAgeHelp": "Maksimum alder på feedinnhold i sekunder. Bruk 0 for å deaktivere aldersfilteret og behandle alle elementer.",
      "cacheTTL": "Cache-TTL",
      "cacheTTLHelp": "Antall dager behandlede feedelementer huskes. Elementer som fortsatt finnes i feeden etter utløp vil bli behandlet og lastet ned på nytt. Standard er 31 dager.",
      "cookie": "Informasjonskapsel (Cookie)",
      "cookieHelp": "Brukes vanligvis ikke",
      "userAgent": "User-Agent",
      "userAgentHelp": "Egendefinert User-Agent for RSS-forespørsler. Bruk når Cloudflare-cookies krever samsvarende User-Agent (f.eks. fra byparr)",
      "categoriesTitle": "Kategorier",
      "categoriesDescription": "Hent tilgjengelige kategorier og velg hva som skal inkluderes.",
      "fetch": "Hent",
      "fetching": "Henter",
      "refetch": "Hent på nytt",
      "fetchFailed": "Klarte ikke å hente kategorier",
      "noCategories": "Ingen kategorier funnet.",
      "fetchToSelect": "Hent kategorier for å velge."
    },
    "list": {
      "added": "Liste lagt til!",
      "addFailed": "Listen kunne ikke legges til",
      "updated": "{{name}} ble oppdatert",
      "deleted": "{{name}} ble slettet.",
      "name": "Navn",
      "type": "Type",
      "enabled": "Aktivert",
      "filters": "Filtre",
      "addTitle": "Legg til liste",
      "updateTitle": "Oppdater liste",
      "description": "Oppdater filtre automatisk fra lister og arr-applikasjoner.",
      "closePanel": "Lukk panel",
      "chooseType": "Velg en type",
      "chooseClient": "Velg en klient",
      "selectClient": "Velg klient",
      "selectClientLabel": "Velg klient",
      "filtersDescription": "Velg filtre som skal oppdateres for denne listen.",
      "cancel": "Avbryt",
      "remove": "Fjern",
      "save": "Lagre",
      "saving": "Lagrer..",
      "selectSomeItems": "Velg...",
      "allItemsSelected": "Alle elementer er valgt",
      "selectAll": "Velg alle",
      "search": "Søk",
      "noOptions": "Ingen alternativer",
      "removeTitle": "Fjern {{name}}",
      "removeText": "Er du sikker på at du vil fjerne {{name}}? Denne handlingen kan ikke angres.",
      "required": "Påkrevd",
      "settingsLegend": "Innstillinger",
      "source": "Kilde",
      "sourceList": "Kildeliste",
      "arrSourceDescription": "Oppdater filtre fra titler i Radarr, Sonarr, Lidarr, Readarr eller Whisparr.",
      "traktSourceDescription": "Bruk en Trakt-liste eller en av standardlistene som hostes av autobrr.",
      "anilistSourceDescription": "Bruk en AniList-liste fra en av standardlistene som hostes av autobrr.",
      "plaintextSourceDescription": "Bruk en ren tekstliste med ett element per linje.",
      "steamSourceDescription": "Følg Steam-ønskelister.",
      "metacriticSourceDescription": "Bruk en Metacritic-liste eller en av standardlistene som hostes av autobrr.",
      "mdblistSourceDescription": "Bruk en MDBList-liste eller en av standardlistene som hostes av autobrr.",
      "listUrl": "Liste-URL",
      "traktHelp": "Standard Trakt-lister. Overstyr med din egen.",
      "traktApiKey": "API-nøkkel",
      "traktApiKeyHelp": "Trakt API-nøkkel. Påkrevd for private lister.",
      "matchRelease": "Samsvar med utgivelse",
      "matchReleaseDesc": "Bruk feltet for 'Samsvar med utgivelser'. Bruker Filmer/Serier-feltet som standard.",
      "includeUnmonitored": "Inkluder uovervåkede",
      "includeUnmonitoredDesc": "Som standard filtreres kun overvåkede titler.",
      "includeAlternateTitles": "Inkluder alternative titler",
      "includeAlternateTitlesDesc": "Inkluder alternative titler i filteret.",
      "skipCleanSanitize": "Omgå opprydding og rensing, og bruk listen som den er",
      "skipCleanSanitizeDesc": "Som standard blir titler automatisk rensket og sjekket for uvanlige tegn.",
      "tagsIncluded": "Tagger inkludert",
      "tagsExcluded": "Tagger ekskludert",
      "metacriticHelp": "Metacritic-lister. Overstyr med din egen.",
      "mdblistHelp": "MDBLists.com-lister. Overstyr med din egen.",
      "includeYear": "Inkluder år",
      "includeYearDesc": "Inkluder utgivelsesåret i filteret for filmer. Krever 'Samsvar med utgivelse'. Eksempel: Movie?Title?2024*",
      "plaintextUrlHelp": "URL til en ren tekstfil med ett element per linje",
      "plaintextUrlPlaceholder": "https://eksempel.no/liste.txt",
      "plaintextTooltip1": "Ren tekst-lister kan lese fra både HTTP-URL-er og lokale filer på disken.",
      "plaintextTooltipRemote": "Ekstern: https://tjeneste.no/fil.txt",
      "plaintextTooltipLocal": "Lokal: file:///home/brukernavn/fil.txt",
      "url": "URL",
      "steamUrlHelp": "Steam-ønskeliste-URL",
      "steamUrlPlaceholder": "https://store.steampowered.com/wishlist/id/BRUKERNAVN/wishlistdata"
    },
    "proxy": {
      "title": "Proxy",
      "addTitle": "Legg til proxy",
      "addDescription": "Legg til proxy som skal brukes med indekserere eller IRC.",
      "added": "Proxy lagt til!",
      "addFailed": "Proxy kunne ikke legges til",
      "updated": "Proxy {{name}} ble oppdatert!",
      "updateFailed": "Proxy kunne ikke oppdateres",
      "deleted": "Proxy {{name}} ble slettet.",
      "name": "Navn",
      "closePanel": "Lukk panel",
      "enabled": "Aktivert",
      "proxyType": "Proxytype",
      "proxyTypeTooltip": "Proxytype. Vanligvis SOCKS5.",
      "proxyTypeHelp": "Vanligvis SOCKS5",
      "addr": "Adresse",
      "addrHelp": "Adresse: scheme://ip:port eller scheme://domene",
      "user": "Bruker",
      "userHelp": "Autentisering: brukernavn",
      "pass": "Passord",
      "passHelp": "Autentisering: passord",
      "test": "Test",
      "cancel": "Avbryt",
      "save": "Lagre"
    },
  "apiKey": {
    "createTitle": "Opprett API-nøkkel",
    "description": "Legg til ny API-nøkkel.",
    "created": "API-nøkkelen {{name}} ble lagt til",
    "deleted": "API-nøkkelen {{name}} ble slettet",
    "name": "Navn",
    "key": "Nøkkel",
    "required": "Påkrevd",
    "closePanel": "Lukk panel",
    "cancel": "Avbryt",
    "create": "Opprett",
    "listTitle": "API-nøkler",
    "listDescription": "Administrer autobrr API-nøklene dine her.",
    "addNew": "Legg til ny",
    "noItems": "Ingen API-nøkler",
    "createCta": "Opprett API-nøkkel",
    "removeTitle": "Fjern API-nøkkel: {{name}}",
    "removeText": "Er du sikker på at du vil fjerne denne API-nøkkelen? Denne handlingen kan ikke angres.",
    "deleteKey": "Slett nøkkel"
  },
    "notification": {
      "settings": "Innstillinger",
      "settingsDescDiscordPrefix": "Opprett en ",
      "settingsDescDiscordSuffix": " på serveren din.",
      "discordWebhookIntegration": "webhook-integrasjon",
      "settingsDescNotifiarr": "Aktiver autobrr-integrasjonen og opprett eventuelt en ny API-nøkkel.",
      "settingsDescLunasea1": "LunaSea tilbyr varsler på tvers av alle enheter knyttet til kontoen din (brukerbasert) eller til en enkelt enhet uten konto, ved å bruke en unik webhook per enhet (enhetsbasert).",
      "settingsDescLunasea2Prefix": "Les ",
      "settingsDescLunasea2Suffix": ".",
      "lunaseaDocs": "LunaSea-dokumentasjonen",
      "settingsDescTelegramPrefix": "Les hvordan du ",
      "settingsDescTelegramSuffix": ".",
      "createBot": "oppretter en bot",
      "settingsDescPushoverPrefix": "Registrer en ny ",
      "settingsDescPushoverSuffix": " og legg til API-tokenet dens her.",
      "pushoverApplication": "applikasjon",
      "eventSounds": "Hendelseslyder",
      "eventSoundsDesc": "Sett egendefinerte lyder per hendelse",
      "settingsDescWebhook": "Send en generisk autobrr JSON-nyttelast til en brukerdefinert webhook-URL.",
      "added": "Varsel lagt til!",
      "addFailed": "Varsel kunne ikke legges til",
      "updated": "{{name}} ble oppdatert",
      "deleted": "{{name}} ble slettet.",
      "required": "Påkrevd",
      "addTitle": "Legg til varsler",
      "addDescription": "Utløs varsler ved forskjellige hendelser.",
      "title": "Varsel",
      "name": "Navn",
      "type": "Type",
      "enabled": "Aktivert",
      "chooseType": "Velg en type",
      "closePanel": "Lukk panel",
      "globalEvents": "Globale hendelser",
      "globalEventsDesc": "Velg standardhendelser som utløses globalt. Disse kan overstyres på filterbasis. La alle være uavmerket for å bruke denne tjenesten kun for filterspesifikke varsler.",
      "perFilterEvents": "Filterspesifikke hendelser",
      "perFilterEventsDesc": "Dette varselet brukes i disse filtrene.",
      "notUsedInFilters": "Brukes ikke i noen filtre",
      "muted": "Dempet",
      "test": "Test",
      "cancel": "Avbryt",
      "save": "Lagre",
      "notificationsLegend": "Varsler",
      "defaultTone": "Standard (brukerens standardtone)",
      "webhookUrl": "Webhook-URL",
      "discordWebhookPlaceholder": "https://discordapp.com/api/webhooks/xx/xx",
      "discordWebhookHelp": "Webhook-URL for Discord-kanal",
      "notifiarrApiKey": "API-nøkkel",
      "notifiarrApiKeyHelp": "Notifiarr API-nøkkel",
      "lunaseaWebhookPlaceholder": "https://notify.lunasea.app/v1/custom/user/TOKEN",
      "lunaseaWebhookHelp": "LunaSea Webhook-URL",
      "botToken": "Bot-token",
      "botTokenHelp": "Bot-token",
      "chatId": "Chat-ID",
      "chatIdHelp": "Chat-ID",
      "messageThreadId": "Meldingstråd-ID",
      "messageThreadIdHelp": "Meldingstråd (emne) i en Supergruppe",
      "telegramProxy": "Telegram API-proxy",
      "telegramProxyHelp": "Omvendt proxy-domene for api.telegram.org. Kun nødvendig hvis nettverket ditt blokkerer Telegram-API-et.",
      "telegramProxyPlaceholder": "http(s)://ip:port",
      "sender": "Avsender",
      "senderHelp": "Egendefinert avsendernavn vist øverst i et varsel",
      "senderPlaceholder": "autobrr",
      "apiToken": "API-token",
      "apiTokenHelp": "API-token",
      "userKey": "Brukernøkkel",
      "userKeyHelp": "Brukernøkkel",
      "priority": "Prioritet",
      "pushoverPriorityHelp": "-2, -1, 0 (standard), 1 eller 2",
      "gotifyUrl": "Gotify-URL",
      "gotifyUrlHelp": "Gotify-URL (uten /message)",
      "gotifyUrlPlaceholder": "https://noen.gotify.server.no",
      "applicationToken": "Applikasjonstoken",
      "applicationTokenHelp": "Applikasjonstoken",
      "ntfyUrl": "NTFY-URL",
      "ntfyUrlHelp": "NTFY-URL",
      "ntfyUrlPlaceholder": "https://ntfy.sh/mittemne",
      "username": "Brukernavn",
      "usernameHelp": "Brukernavn",
      "password": "Passord",
      "passwordHelp": "Passord",
      "accessToken": "Tilgangstoken",
      "accessTokenHelp": "Tilgangstoken. Bruk denne eller Brukernavn + passord",
      "tags": "Tags",
      "ntfyTagsHelp": "Kommaseparerte tagger/ikoner for ntfy-varsler",
      "ntfyTagsPlaceholder": "download,arr,white_check_mark",
      "ntfyPriorityHelp": "Maks 5, 4, 3 (standard), 2, 1 Min",
      "url": "URL",
      "urlHelp": "URL",
      "shoutrrrDocsPrefix": "Se full dokumentasjon ",
      "shoutrrrServices": "Tjenester",
      "shoutrrrUrlPlaceholder": "smtp://brukernavn:passord@vert:port/?from=fraAdresse&to=mottaker1",
      "httpMethod": "HTTP-metode",
      "httpMethodDefault": "POST (standard)",
      "httpMethodTooltip": "HTTP-metode for webhook-forespørselen. Standard er POST.",
      "webhookPlaceholder": "https://eksempel.no/webhook",
      "customHeaders": "Egendefinerte headere",
      "customHeadersHelp": "Kommaseparerte NØKKEL=verdi-par (f.eks. Authorization=Bearer token,X-Custom=verdi)",
      "customHeadersPlaceholder": "Authorization=Bearer token,X-Custom-Header=verdi"
    },
    "irc": {
      "listTitle": "IRC",
      "listDescription": "IRC-nettverk og kanaler. Klikk på et nettverk for å se kanalstatus.",
      "addNew": "Legg til ny",
      "networkHealthy": "Nettverket er friskt",
      "networkUnhealthy": "Nettverket er ustabilt",
      "networkDisabled": "Nettverket er deaktivert",
      "collapseTitle": "kollaps",
      "expandTitle": "utvid",
      "collapse": "Kollaps",
      "expand": "Utvid",
      "network": "Nettverk",
      "noNetworks": "Ingen nettverk",
      "noNetworksSubtitle": "Settes vanligvis opp via indekserere",
      "addNewNetwork": "Legg til nytt nettverk",
      "toggleSuccess": "{{name}} ble {{state}}.",
      "enabledState": "aktivert",
      "disabledState": "deaktivert",
      "connectedSince": "Tilkoblet siden: {{time}}",
      "tlsSecured": "Sikret med TLS",
      "tlsInsecure": "Usikret, bruker ikke TLS",
      "channel": "Kanal",
      "monitoringSince": "Overvåker siden",
      "lastAnnounce": "Siste annonsering",
      "monitoring": "overvåker",
      "hide": "Skjul",
      "view": "Vis",
      "networkDeleted": "Nettverket {{name}} ble slettet",
      "networkRestarted": "{{name}} ble startet på nytt",
      "removeNetworkTitle": "Fjern nettverk: {{name}}",
      "removeNetworkText": "Er du sikker på at du vil fjerne dette nettverket? Denne handlingen kan ikke angres.",
      "edit": "Rediger",
      "restart": "Start på nytt",
      "delete": "Slett",
      "announceReprocessed": "Annonsering sendt til ny behandling!",
      "reprocessAnnounce": "Behandle annonsering på nytt",
      "options": "Alternativer",
      "scrollOnNewMessage": "Rull til bunnen ved ny melding",
      "title": "Nettverk",
      "addWarning": "LEGG TIL NETTVERK VIA INDEKSERERE! BRUK KUN DETTE HVIS DU HAR SLETTET NETTVERK",
      "added": "IRC-nettverk lagt til. Det kan ta opptil 30 sekunder før nettverket kommer på nett.",
      "addFailed": "IRC-nettverket kunne ikke legges til",
      "updated": "{{name}} ble oppdatert",
      "deleted": "{{name}} ble slettet.",
      "required": "Påkrevd",
      "name": "Navn",
      "enabled": "Aktivert",
      "server": "Server",
      "serverPlaceholder": "Adresse: f.eks. irc.server.net",
      "port": "Port",
      "portPlaceholder": "F.eks. 6667",
      "tls": "TLS",
      "skipTls": "Hopp over TLS-verifisering (usikkert)",
      "password": "Passord",
      "passwordHelp": "Nettverkspassord",
      "passwordUpdateHelp": "Nettverkspassord, brukes vanligvis ikke.",
      "nick": "Nick",
      "nickPlaceholderAdd": "bot-nick",
      "nickPlaceholderUpdate": "nick",
      "authAccount": "Autentiseringskonto",
      "authAccountPlaceholder": "Autentiseringskonto",
      "authPassword": "Autentiseringspassord",
      "inviteCommand": "Invitasjonskommando",
      "channels": "Kanaler",
      "channelsDesc": "Kanaler som skal kobles til.",
      "channelsUpdateDesc": "Kanaler legges til når du setter opp IRC-indekserere. Ikke rediger med mindre du vet hva du gjør.",
      "channelPassword": "Kanalpassord",
      "remove": "Fjern",
      "noChannels": "Ingen kanaler!",
      "addChannel": "Legg til kanal",
      "bouncer": "Bouncer (BNC)",
      "bouncerAddress": "Bouncer-adresse",
      "bouncerAddressHelp": "Adresse: f.eks. bouncer.server.net:6697",
      "botMode": "IRCv3 Bot-modus",
      "proxy": "Proxy",
      "proxyDesc": "Angi en proxy som skal brukes ved tilkobling til IRC-serveren.",
      "selectProxy": "Velg proxy",
      "selectProxyPlaceholder": "Velg en proxy",
      "identification": "Identifisering",
      "identificationDesc": "Identifiser med SASL eller NickServ. De fleste nettverk støtter SASL, men noen gjør det ikke.",
      "mechanism": "Mekanisme",
      "account": "Konto",
      "accountHelp": "NickServ- / SASL-konto. For grupperte nick, prøv hovedkontoen.",
      "passwordSaslHelp": "NickServ- / SASL-passord.",
      "chooseType": "Velg en type"
    },
    "indexer": {
      "title": "Indekserer",
      "addTitle": "Legg til indekserer",
      "addDescription": "Legg til indekserer.",
      "added": "Indeksereren ble lagt til",
      "addFailed": "Indeksereren kunne ikke legges til",
      "updated": "{{name}} ble oppdatert",
      "deleted": "{{name}} ble slettet.",
      "indexer": "Indekserer",
      "chooseIndexer": "Velg en indekserer",
      "required": "Påkrevd",
      "defaultValueValidation": "Standardverdi, vennligst rediger",
      "enabled": "Aktivert",
      "baseUrl": "Basis-URL",
      "baseUrlHelp": "Overstyr basis-URL hvis den er blokkert av internettleverandøren din.",
      "cancel": "Avbryt",
      "save": "Lagre",
      "closePanel": "Lukk panel",
      "ircTitle": "IRC",
      "ircDesc": "Nettverk og kanaler konfigureres automatisk i bakgrunnen.",
      "torznabTitle": "Torznab",
      "torznabDesc": "Torznab-feed",
      "newznabTitle": "Newznab",
      "newznabDesc": "Newznab-feed",
      "rssTitle": "RSS",
      "rssDesc": "RSS-feed",
      "settingsIrcTitle": "IRC",
      "settingsIrcDesc": "Nettverk og kanaler konfigureres automatisk i bakgrunnen.",
      "ircGuideTooltip": "Vennligst les IRC-guiden vår hvis du ikke er kjent med IRC.",
      "name": "Navn",
      "url": "URL",
      "torznabUrlHelp": "Torznab-URL. Bruk kun URL-en uten ekstra parametere.",
      "newznabUrlHelp": "Newznab-URL. Bruk kun URL-en uten ekstra parametere.",
      "urlFormatTitle": "Prowlarr og Jackett har forskjellige formater:",
      "prowlarr": "Prowlarr",
      "jackett": "Jackett",
      "apiKey": "API-nøkkel",
      "downloadType": "Nedlastingstype",
      "downloadTypeTooltip": "Noen feeder må tvinges til Magnet.",
      "downloadTypeHelp": "Sett til Torrent eller Magnet avhengig av indeksereren.",
      "downloadTypeTooltip2": "Noen feeder må tvinges til Magnet.",
      "categoriesTitle": "Kategorier",
      "categoriesDescription": "Hent tilgjengelige kategorier og velg hva som skal inkluderes.",
      "fetch": "Hent",
      "fetching": "Henter",
      "refetch": "Hent på nytt",
      "fetchFailed": "Klarte ikke å hente kategorier",
      "fetchNeedsUrl": "Skriv inn en URL for å hente kategorier",
      "noCategories": "Ingen kategorier funnet.",
      "fetchToSelect": "Hent kategorier for å velge.",
      "testApi": "Test API",
      "testApiSuccess": "API-test vellykket!",
      "ok": "OK!",
      "error": "FEIL",
      "externalIdentifier": "Ekstern identifikator",
      "externalIdentifierHelp": "Ekstern identifikator for arr-applikasjoner. Hvis du bruker Prowlarr, sett det slik: {{name}} (Prowlarr)",
      "externalIdentifierTooltip1": "Ekstern identifikator for bruk med arr-applikasjoner for å få funksjoner som seed-grenser til å fungere.",
      "externalIdentifierTooltip2": "Dette må samsvare med indekserernavnet i arr-applikasjonen din. Hvis du bruker Prowlarr vil det sannsynligvis være \"{{name}} (Prowlarr)\"",
      "secretFieldTooltip": "Dette feltet tar ikke en full URL. Bruk kun alfanumeriske strenger som uqcdi67cibkx3an8cmdm.",
      "proxy": "Proxy",
      "proxyDesc": "Angi en proxy som skal brukes for nedlastinger av .torrent-filer og feeder.",
      "selectProxy": "Velg proxy",
      "selectProxyPlaceholder": "Velg en proxy",
      "chooseType": "Velg en type",
      "editFeeds": "Rediger RSS-feeder i Innstillinger -> Feeder"
    },
    "releaseProfile": {
      "title": "Duplikatprofil",
      "added": "Profilen ble lagt til",
      "addFailed": "Profilen kunne ikke legges til",
      "deleted": "Profilen {{name}} ble slettet!",
      "fields": {
        "name": "Navn",
        "releaseName": "Utgivelsesnavn",
        "hash": "Hash",
        "title": "Tittel",
        "subTitle": "Undertittel",
        "year": "År",
        "month": "Måned",
        "day": "Dag",
        "source": "Kilde",
        "resolution": "Oppløsning",
        "codec": "Kodek",
        "container": "Container",
        "dynamicRange": "Dynamisk område",
        "audio": "Lyd",
        "group": "Gruppe",
        "season": "Sesong",
        "episode": "Episode",
        "website": "Nettsted/tjeneste",
        "proper": "Proper",
        "repack": "Repack",
        "edition": "Utgave",
        "hybrid": "Hybridversjon",
        "language": "Språk"
      },
      "descriptions": {
        "releaseName": "Fullt utgivelsesnavn",
        "hash": "Normalisert hash for utgivelsesnavnet. Bruk med utgivelsesnavn for eksakt samsvar",
        "title": "Tolket tittel",
        "subTitle": "Tolket undertittel som episodenavn",
        "dailyReleases": "For daglige utgivelser (Daily releases)",
        "group": "Utgivelsesgruppe",
        "website": "Tjenester som AMZN/HULU/NF",
        "dynamicRange": "Dynamisk område (HDR, DV osv.)",
        "edition": "Utgave og kutt (Cut)",
        "language": "Språk og region"
      }
    },
    "cleanupJob": {
      "title": "Oppryddingsjobb",
      "created": "Oppryddingsjobb opprettet",
      "createFailed": "Jobben kunne ikke opprettes",
      "updated": "Jobb oppdatert",
      "updateFailed": "Jobben kunne ikke oppdateres",
      "deleted": "{{name}} slettet",
      "enableDesc": "Aktiver denne oppryddingsjobben",
      "namePlaceholder": "Ukentlig opprydding",
      "schedule": "Tidsplan (Cron)",
      "schedulePlaceholder": "0 3 * * *",
      "scheduleHelp": "Cron-uttrykk. Eksempler: '0 3 * * *' = daglig kl. 03:00, '0 */6 * * *' = hver 6. time",
      "olderThan": "Eldre enn",
      "olderThanPlaceholder": "30",
      "olderThanHelp": "Slett utgivelser eldre enn denne varigheten",
      "indexersOptional": "Indekserere (valgfritt)",
      "statusesOptional": "Statuser (valgfritt)",
      "leaveEmptyIndexers": "La stå tomt for å gjelde alle indekserere",
      "leaveEmptyStatuses": "La stå tomt for å gjelde alle statuser",
      "executionHistory": "Kjøringshistorikk",
      "lastRun": "Siste kjøring:",
      "status": "Status:"
    }
  },
  "listScreens": {
    "common": {
      "enabled": "Aktivert",
      "name": "Navn",
      "type": "Type",
      "edit": "Rediger",
      "addNew": "Legg til ny",
      "unknownError": "En ukjent feil oppstod"
    },
    "downloadClients": {
      "title": "Nedlastingsklienter",
      "description": "Administrer nedlastingsklienter.",
      "host": "Vert",
      "noItems": "Ingen nedlastingsklienter",
      "addNewItem": "Legg til ny klient",
      "toggleSuccess": "{{name}} ble {{state}}.",
      "enabledState": "aktivert",
      "disabledState": "deaktivert"
    },
    "notifications": {
      "title": "Varsler",
      "description": "Konfigurer varslingstjenester og deres globale hendelsesutløsere.",
      "events": "Hendelser",
      "filters": "Filtre",
      "noItems": "Ingen varsler",
      "addNewItem": "Opprett nytt varsel",
      "infoTitle": "Overstyringer per filter:",
      "infoBody": "Du kan overstyre disse globale innstillingene for spesifikke filtre i hvert filters varslingsfane. Globale hendelser er valgfrie - du kan opprette varslingstjenester uten hendelser og kun konfigurere dem på filternivå. Systemhendelser (IRC frakoblet/tilkoblet, programoppdateringer) bruker alltid globale innstillinger.",
      "toggleSuccess": "{{name}} ble {{state}}.",
      "enabledState": "aktivert",
      "disabledState": "deaktivert"
    },
    "indexers": {
      "title": "Indekserere",
      "description": "Indekserer-innstillinger for IRC-, RSS-, Newznab- og Torznab-baserte indekserere.",
      "descriptionGeneric": "Generiske RSS-/Newznab-/Torznab-feeder kan legges til her ved å velge en av de <strong>Generiske</strong> indeksererne.",
      "implementation": "Implementasjon",
      "noItems": "Ingen indekserere",
      "addNewItem": "Legg til ny indekserer",
      "updated": "{{name}} ble oppdatert",
      "deprecated": {
        "title": "Utgåtte indekserere",
        "description": "Disse indeksererne er fjernet fra autobrr. De kan ikke brukes eller velges i filtre. Utgivelsene beholdes og viser fortsatt navnet sitt.",
        "removed": "Fjernet indekserer",
        "moreInfo": "Mer informasjon",
        "usedByFilters_one": "Brukes av {{count}} filter",
        "usedByFilters_other": "Brukes av {{count}} filtre",
        "pruneAll": "Fjern fra alle filtre",
        "pruneOne": "Fjern fra filtre",
        "pruneTitle": "Fjern utgåtte indekserere fra filtre",
        "pruneText": "Er du sikker på at du vil fjerne alle utgåtte indekserere fra filtrene dine? Utgivelsene beholdes, men indeksererne vil ikke lenger være knyttet til noen filtre. Denne handlingen kan ikke angres.",
        "pruneOneTitle": "Fjern {{name}} fra filtre",
        "pruneOneText": "Er du sikker på at du vil fjerne {{name}} fra alle filtre? Historiske utgivelser og lagrede indeksererdata beholdes.",
        "pruneSuccess_one": "Fjernet {{count}} tilkobling for en utgått indekserer fra filtre",
        "pruneSuccess_other": "Fjernet {{count}} tilkoblinger for utgåtte indekserere fra filtre",
        "pruneError": "Kunne ikke fjerne utgåtte indekserere fra filtre",
        "purge": "Slett lagrede data",
        "purgeTitle": "Slett lagrede data for {{name}}",
        "purgeText": "Dette sletter den lagrede indeksererkonfigurasjonen og påloggingsinformasjonen permanent. Historiske utgivelser beholder det lesbare indekserernavnet. Denne handlingen kan ikke angres.",
        "purgeSuccess": "De lagrede dataene for den arkiverte indeksereren ble slettet",
        "purgeError": "Kunne ikke slette de lagrede dataene for den arkiverte indeksereren"
      }
    },
    "proxies": {
      "title": "Proxyer",
      "description": "Proxyer som kan brukes med indekserere, feeder og IRC.",
      "noItems": "Ingen proxyer",
      "addNewItem": "Legg til ny proxy",
      "toggleSuccess": "Proxyen {{name}} ble {{state}}.",
      "toggleError": "Proxy-status kunne ikke oppdateres",
      "enabledState": "aktivert",
      "disabledState": "deaktivert"
    },
    "lists": {
      "title": "Lister",
      "description": "Lister kan automatisk oppdatere filtrene dine fra arr-applikasjoner eller andre kilder.",
      "filters": "Filtre",
      "noItems": "Ingen lister",
      "addNewItem": "Legg til ny liste",
      "toggleSuccess": "Listen {{name}} ble {{state}}.",
      "toggleError": "Listestatus kunne ikke oppdateres",
      "refreshSuccess": "Listen {{name}} ble hentet.",
      "refreshError": "Klarte ikke å oppdatere {{name}}. Feil: {{error}}",
      "deleted": "{{name}} ble slettet.",
      "removeTitle": "Fjern liste: {{name}}",
      "removeText": "Er du sikker på at du vil fjerne denne listen? Denne handlingen kan ikke angres.",
      "copyId": "Kopier liste-ID",
      "copyIdSuccess": "Liste-ID {{id}} kopiert til utklippstavlen.",
      "copyIdError": "Kunne ikke kopiere liste-ID-en til utklippstavlen.",
      "refresh": "Oppdater",
      "delete": "Slett",
      "enabledState": "aktivert",
      "disabledState": "deaktivert"
    },
    "feeds": {
      "title": "Feeder",
      "description": "Administrer RSS-, Newznab- og Torznab-feeder.",
      "lastRun": "Siste kjøring",
      "nextRun": "Neste kjøring",
      "noItems": "Ingen feeder",
      "noItemsDesc": "Settes opp via indekserere",
      "toggleSuccess": "{{name}} ble {{state}}.",
      "enabledState": "aktivert",
      "disabledState": "deaktivert",
      "deleted": "Feeden {{name}} ble slettet",
      "cacheCleared": "Hurtigbuffer for feeden {{name}} ble tømt!",
      "forceRunSuccess": "Feeden {{name}} ble tvangskjørt.",
      "forceRunError": "Klarte ikke å tvangskjøre {{name}}. Feil: {{error}}",
      "removeTitle": "Fjern feed: {{name}}",
      "removeText": "Er du sikker på at du vil fjerne denne feeden? Denne handlingen kan ikke angres.",
      "removeCacheTitle": "Fjern hurtigbuffer for feed: {{name}}",
      "removeCacheText": "Er du sikker på at du vil fjerne hurtigbufferen for feeden? Denne handlingen kan ikke angres.",
      "forceRunTitle": "Tvangskjør feed: {{name}}",
      "forceRunText": "Er du sikker på at du vil tvangskjøre feeden {{name}}? Det er avgjørende å respektere reglene for RSS-intervall for å unngå potensielle IP-utestengelser.",
      "toggle": "Veksle",
      "forceRun": "Tvangskjør",
      "viewLatestRun": "Vis siste kjøring",
      "clearCache": "Tøm hurtigbuffer for feed",
      "clearCacheTitle": "Tøm all hurtigbuffer for feed manuelt",
      "delete": "Slett"
    }
  }
}
